module.exports = __webpack_public_path__ + "static/media/wharton-logo-blue-sm.5f2fe62d.png";